// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mq-0";